module.exports = __webpack_public_path__ + "static/media/logo-brcomerce.35b20daf.svg";